<template>
	<section scope-slot="empty" class="section">
		<div class="content has-text-grey has-text-centered">
			<p>{{ tableType }} will appear here once configured</p>
			<!-- <p>Head over to the create page to create the first {{ tableType }}.</p> -->
		</div>
	</section>
</template>

<script>
export default {
	props: {
		tableType: {
			type: String,
			required: true
		}
	}
};
</script>
